module.exports = __webpack_public_path__ + "static/media/productos_white.65ec8361.svg";